<template>
  <div>
    <company-list :items="$store.state.company.companies" />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import CompanyList from '../components/company/CompanyList.vue'

export default {
  name: 'Users',
  components: {
    CompanyList
  },
  methods: {
    ...mapActions('company', ['getCompanies'])
  },
  mounted() {
    this.getCompanies()
  }
}
</script>
